(function(){
  if(window.CXKVariantCardSlideshow)return;
  window.CXKVariantCardSlideshow=true;

  var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer=null;

  if('IntersectionObserver' in window){
    observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        entry.target.dataset.cxkVariantVisible=entry.isIntersecting?'1':'0';
      });
    },{rootMargin:'140px 0px',threshold:0.05});
  }

  function initCard(card,index){
    if(!card)return;
    var media=card.querySelector('.cxk-variant-slideshow-media');
    if(!media)return;
    if(card.dataset.cxkVariantReady==='1'&&card._cxkVariantMedia===media)return;

    if(card._cxkVariantInterval)window.clearInterval(card._cxkVariantInterval);

    var slides=[].slice.call(media.querySelectorAll('.cxk-card-variant-slide'));
    if(!slides.length)return;

    card.dataset.cxkVariantReady='1';
    card._cxkVariantMedia=media;
    card.dataset.cxkVariantVisible=observer?'0':'1';
    if(observer)observer.observe(card);

    slides.forEach(function(slide,i){
      slide.classList.toggle('is-active',i===0);
      slide.classList.remove('is-prev');
      slide.addEventListener('error',function(){
        slide.dataset.cxkVariantFailed='1';
        slide.classList.remove('is-active','is-prev');
        var fallback=slides.find(function(candidate){
          return candidate.dataset.cxkVariantFailed!=='1';
        });
        if(fallback)fallback.classList.add('is-active');
      },{once:true});
    });

    if(reduceMotion||slides.length<2)return;

    var current=0;
    function advance(){
      if(card.dataset.cxkVariantVisible!=='1')return;
      var available=slides.filter(function(slide){
        return slide.dataset.cxkVariantFailed!=='1';
      });
      if(available.length<2)return;
      current=available.indexOf(media.querySelector('.cxk-card-variant-slide.is-active'));
      if(current<0)current=0;
      var previous=available[current];
      var nextIndex=(current+1)%available.length;
      var next=available[nextIndex];

      previous.classList.remove('is-active');
      previous.classList.add('is-prev');
      next.classList.remove('is-prev');
      next.classList.add('is-active');

      window.setTimeout(function(){
        previous.classList.remove('is-prev');
      },700);

      current=nextIndex;
    }

    var initialDelay=2400+((index||0)%6)*220;
    window.setTimeout(function(){
      if(!document.documentElement.contains(card))return;
      card._cxkVariantInterval=window.setInterval(advance,3400);
    },initialDelay);
  }

  function scan(root){
    var scope=root&&root.querySelectorAll?root:document;
    [].slice.call(scope.querySelectorAll('.product-card-wrapper, .cxkp-product')).forEach(initCard);
  }

  function boot(){
    scan(document);
    var mo=new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        [].slice.call(m.addedNodes||[]).forEach(function(node){
          if(node.nodeType!==1)return;
          if(node.matches&&node.matches('.product-card-wrapper, .cxkp-product'))initCard(node,0);
          scan(node);
        });
      });
    });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();

  document.addEventListener('shopify:section:load',function(e){scan(e.target)});
})();
